export default "__VITE_ASSET__DXJyyPKY__"